import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./App.css";
import { BrowserRouter, Outlet, Route, Switch, redirect } from "react-router-dom";
import registerServiceWorker from "./registerServiceWorker";
import App from "./App";
import axios from 'axios'
import Login from "./components/auth/login";
import Register from "./components/auth/register";
import "bootstrap/dist/css/bootstrap.min.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import Account from "./components/user/account";
import CircularProgress from '@material-ui/core/CircularProgress';

const getAuth = async () => {
  const { data: user } = await axios.get('/api/user')
  return user
}

class RequireAuth extends React.Component {
  constructor(props) {
    super();
    this.state = { ...props };
  }
  componentWillReceiveProps = async (props) => {
    this.setState({
      user: props.user
    })
  }
  render() {
    if (!this.state.user) {
      return <div className="loadingContainer"><CircularProgress color="secondary" className="loadingCircle"/></div>;
    } else {
      return this.state.user ? 
      this.state.component === 'Account' ? 
      <Account user={this.state.user}/> 
      : <App /> 
      : window.location = this.state.redirectTo;
    }

  }
}

class AuthApp extends React.Component {
  constructor() {
    super();
    this.state = { data: [] };
  }
  componentDidMount = async () => {
    const token = await getAuth();
    this.setState({
      user: token
    })
    console.log(this.state.user)
  }
  render() {
    
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <RequireAuth redirectTo="/login" component="App" user={this.state.user}/>
          </Route>
          <Route exact path="/account">
            <RequireAuth redirectTo="/login" component="Account" user={this.state.user}/>
          </Route>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/register">
            <Register />
          </Route>
          <Route exact path="*">
            <h1>Not Found</h1>
          </Route>
          {/* <Route path="/" element={<RequireAuth redirectTo="/login" user={this.state.user} />} >
            <Route exact path="/" element={<App />} />    
          </Route>
          <Route exact path="/login" element={<Login />} />
          <Route path="*" element={<h1>not found</h1>} /> */}
        </Switch>
      </BrowserRouter>
    )
  }
}

ReactDOM.render(<AuthApp />, document.getElementById("root"));
// ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js